<template>
  <div class="detail-page">
    <header class="page-banner">
      <div class="page-banner__grid" aria-hidden="true" />
      <div class="page-banner__inner">
        <p class="page-banner__crumb">
          <router-link to="/">首页</router-link>
          <span class="sep">/</span>
          <router-link to="/solutions">解决方案</router-link>
        </p>
        <h1 class="page-banner__title">{{ detail?.title || '解决方案详情' }}</h1>
        <p v-if="detail?.subtitle" class="page-banner__sub">{{ detail.subtitle }}</p>
      </div>
    </header>

    <div class="container detail-body">
      <router-link class="back-link" to="/solutions">← 返回解决方案列表</router-link>

      <div v-if="loading" class="state">加载中…</div>
      <div v-else-if="error" class="state state--err">{{ error }}</div>
      <article v-else-if="detail" class="detail-card">
        <div class="detail-main">
          <!-- <h2 class="detail-heading">{{ detail.title }}</h2> -->
          <div v-if="detail.contentHtml" class="detail-rich" v-html="detail.contentHtml" />
          <div v-else-if="detail.contentPlain" class="detail-plain">{{ detail.contentPlain }}</div>
          <div v-if="!detail.contentPlain && !detail.contentHtml" class="detail-empty">
            暂无详细介绍，请咨询售前。
          </div>
          <router-link class="back-link back-link--bottom" to="/solutions">返回</router-link>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { fetchSolutionDetail } from '../api/solutions'

export default {
  name: 'SolutionDetailView',
  data() {
    return {
      detail: null,
      loading: true,
      error: ''
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.load()
      }
    }
  },
  methods: {
    async load() {
      const id = this.$route.params.id
      this.loading = true
      this.error = ''
      this.detail = null
      try {
        const d = await fetchSolutionDetail(id)
        this.detail = d
        if (!d) this.error = '未找到该方案或接口异常'
      } catch (e) {
        this.error = '加载失败，请稍后重试'
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style scoped>
.detail-page {
  padding-top: 76px;
  min-height: 100vh;
  background: #f1f5f9;
}

.page-banner {
  position: relative;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0f172a;
  background: linear-gradient(145deg, #e8f3ff 0%, #dbeafe 55%, #cfe5ff 100%);
  overflow: hidden;
}

.page-banner__grid {
  position: absolute;
  inset: 0;
  opacity: 0.2;
  background-image:
    radial-gradient(circle at 20% 30%, rgba(56, 189, 248, 0.15) 0%, transparent 45%),
    linear-gradient(rgba(56, 189, 248, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(56, 189, 248, 0.06) 1px, transparent 1px);
  background-size: auto, 36px 36px, 36px 36px;
}

.page-banner__inner {
  position: relative;
  z-index: 1;
  padding: 40px 20px 36px;
  text-align: center;
  max-width: 900px;
}

.page-banner__crumb {
  font-size: 14px;
  margin: 0 0 16px;
  color: #94a3b8;
}

.page-banner__crumb a { color: #2563eb; }
.page-banner__crumb a:hover { text-decoration: underline; }
.page-banner__crumb .sep { margin: 0 8px; color: #64748b; }

.page-banner__title {
  font-size: clamp(22px, 3.5vw, 34px);
  font-weight: 700;
  margin: 0 0 10px;
  line-height: 1.3;
}

.page-banner__sub {
  font-size: 16px;
  color: #475569;
  margin: 0;
  line-height: 1.6;
}

.detail-body { padding: 24px 20px 80px; }

.back-link {
  display: inline-block;
  font-size: 14px;
  color: #0284c7;
  margin-bottom: 20px;
  font-weight: 500;
}
.back-link--bottom {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 10px auto 0;
  padding: 10px 18px;
  font-size: 14px;
  line-height: 1;
  color: #2563eb;
  font-weight: 600;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #eff6ff;
}
.back-link--bottom::before {
  content: '';
  width: 8px;
  height: 8px;
  border-left: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(45deg);
}

.back-link:hover { text-decoration: underline; }

.state {
  padding: 48px;
  text-align: center;
  color: #64748b;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.state--err { color: #b91c1c; }

.detail-card {
  background: transparent;
  border-radius: 0;
  border: none;
  overflow: visible;
  box-shadow: none;
  max-width: 980px;
  margin: 0 auto;
}

.detail-main {
  padding: 8px 0 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.detail-heading {
  font-size: 24px;
  color: #0f172a;
  margin: 0;
  font-weight: 700;
}

.detail-intro {
  font-size: 15px;
  line-height: 1.75;
  color: #475569;
  margin: 0;
}

.detail-plain {
  font-size: 15px;
  line-height: 1.85;
  color: #334155;
  margin: 0;
  white-space: pre-wrap;
}

.detail-rich {
  font-size: 15px;
  line-height: 1.8;
  color: #334155;
}

.detail-rich :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.detail-rich :deep(p) {
  margin: 0 0 12px;
}

.detail-rich :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0;
}

.detail-rich :deep(table th),
.detail-rich :deep(table td) {
  border: 1px solid #e2e8f0;
  padding: 8px 10px;
}
/* 富文本常带内联 background/background-color，统一清掉避免出现“白色底块字” */
.detail-rich :deep(*) {
  background: transparent !important;
  background-color: transparent !important;
}
/* 图片和表格单元格不做透明清洗，保持原始展示 */
.detail-rich :deep(img),
.detail-rich :deep(table),
.detail-rich :deep(table th),
.detail-rich :deep(table td) {
  background: initial !important;
  background-color: initial !important;
}

.detail-empty {
  font-size: 14px;
  color: #94a3b8;
}

@media (max-width: 900px) {
  .detail-main { padding: 4px 0 16px; }
}
</style>



